const PRE_K = 'Pre-K';
const KINDERGARTEN = 'K';

const GRADE_VALUE_MAPPING = {
  pk: PRE_K,
  'pre-k': PRE_K,
  prekindergarten: PRE_K,
  'pre kindergarten': PRE_K,
  k: KINDERGARTEN,
  kg: KINDERGARTEN,
  kindergarten: KINDERGARTEN,
};

// Grades synced from external SIS providers come in different formats
// (e.g. 'PK', 'KG', zero-padded '01'). Normalize them to the canonical
// values used by gradeListOptions: Pre-K, K, 1-12 and Other.
export const normalizeGradeValue = (grade) => {
  if (!grade) {
    return '';
  }
  const value = String(grade).trim();
  const mapped = GRADE_VALUE_MAPPING[value.toLowerCase()];
  if (mapped) {
    return mapped;
  }
  if (/^\d+$/.test(value)) {
    const number = parseInt(value, 10);
    if (number >= 1 && number <= 12) {
      return String(number);
    }
  }
  return 'Other';
};
